export default __webpack_public_path__ + "static/media/04.6e85e245.jpg";